export const TYPE_TAG = "tag"
export const TYPE_CUSTOMER_TAG = "customer-tag"
export const TYPE_MANUFACTURER = "manufacturer"
export const TYPE_CUSTOMER = "customer-type"
export const TYPE_VENDOR = "vendor"


// WEBPACK FOOTER //
// ./src/state/label/labelTypes.ts